import { createContext, useContext } from 'react';
import type { ModalListItem } from 'src/components/ModalContainer';
import type { QuickActionPageGroup } from 'src/components/QuickActions/quick-action-pages.types';

export interface QuickAction extends ModalListItem {
  order?: number;
  /** Hidden until the search starts a word of its title or keywords. */
  revealedBySearch?: boolean;
  handler: () => void;
}

export type QuickActionKey = string | ((...args: unknown[]) => unknown);

export const QuickActionsContext = createContext<{
  addActions: (actions: QuickAction | QuickAction[]) => void;
  removeActions: (actions: QuickAction | QuickAction[]) => void;
  updateAndRestoreAction: (
    actionKey: QuickActionKey,
    data: Partial<QuickAction>,
    options?: {
      skip?: boolean;
    },
  ) => () => void;
  getActionById: (actionKey: QuickActionKey) => QuickAction | null;
  setPageGroups: (pageGroups: QuickActionPageGroup[]) => void;
}>({
  addActions: () => undefined,
  removeActions: () => undefined,
  updateAndRestoreAction: () => () => undefined,
  getActionById: () => null,
  setPageGroups: () => undefined,
});

export const useQuickActionsContext = () => useContext(QuickActionsContext);
